import { useLocation, useNavigate } from "react-router-dom";
import {
  getUserData,
} from "../../../../utils/localStorage";
import { useEffect, useState } from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import StoreMenu from "../../../StoreMenu";
import { closeOrder } from "../../../../services/BulkProcessing/BulkProcessing";
import SuccessModal from "../../../SuccessModal";
import { getStoreRiderInfo, searchRiderOrderBulkOutForDelivery } from "../../../../services/StoreRiderInfo/StoreRiderInfo";
import { FloatLabel } from "primereact/floatlabel";
import ButtonLink from "../../../../ButtonLink";

const { innerWidth: width, innerHeight: height } = window;

const BulkOutForDelivery = () => {
  const navigate = useNavigate();

  const { storeData, userProfileRole, brandProfileData, userProfileData } =
    getUserData();

    const location = useLocation();
    const { state } = location || {}; // Fallback to prevent undefined errors

  const storeId = storeData.id;
  let brandId = brandProfileData.id;


  const jobType = 'delivery';

  const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  const [page, setPage] = useState(0);
  const [sumOfBalanceAmount, setSumOfBalanceAmount] = useState(0);
  const [sumOfOrderCount, setSumOfOrderCount] = useState(0);
  const [visible, setVisible] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermClean, setSearchTermClean] = useState(false);
  const [searchFilterValue, setSearchFilterValue] = useState("INVOICE");
  const [searchTypeToggle, setSearchTypeToggle] = useState(false);
  const [isPayNowButtonPressed, setIsPayNowButtonPressed] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const [selectedOrderIds, setSelectedOrderIds] = useState([]);

  const [riderInfo, setRiderInfo] = useState([]);

  const fetchStoreRiderInfo = () => {
    getStoreRiderInfo(storeId)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;  
          const newRes = Res.map((item) => ({
            name: item.fullName,
            value: item.id,
          }));        
          setRiderInfo(newRes);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };


  const fetchStoreOrders = data => {
    searchRiderOrderBulkOutForDelivery(
     storeId,
     jobType,
     data,
   )
   .then(response => {
     const Res = response.data;
     setCustomerALLOrdersData(Res);
   })
  .catch(err => {
   console.error('Error:', err);
 })
};

  useEffect(() => {
    fetchStoreRiderInfo();
  }, []);


  const [assignRiderValue, setAssignRiderValue] = useState('');
  const handleAssignRiderChange = selectedItem => {
    setAssignRiderValue(selectedItem);
  };

  const searchTermApiCall = text => {
    if (text !== '') {
      setSearchTerm(text);
    const newData = {
      riders: [assignRiderValue],
      jobStatus: [
        'REQUEST_RECEIVED',
        'ASSIGNED_TO_RIDER',
        'RESCHEDULE_BY_CUSTOMER',
        'RESCHEDULE_BY_RIDER',
      ],
      offset: 0,
      searchBy: searchFilterValue !== "" ? searchFilterValue : "INVOICE",
      searchText: text,
      sortOrder: 'desc',
      sortBy: 'id',
      limit: 10,
      offset: page * 10,
    };
      fetchStoreOrders(newData);
    } else {
      setSearchTerm('');
      setCustomerALLOrdersData([]);
      setPage(0);
      setSearchTermClean(true);
    }
  };

  const [tabularView, setTabularView] = useState("tab");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedInvoiceNos, setSelectedInvoiceNos] = useState([]);
 
  const handleSearchFilterChange = async (selectedItem) => {
    setSearchFilterValue(selectedItem);
    handleSearchType();
  };

  const FilterList = [
    {
      name: "By Name",
      value: "NAME",
    },
    {
      name: "By Invoice No.",
      value: "INVOICE",
    },
    {
      name: "By Mobile No.",
      value: "MOBILE",
    },
  ];

  const handleSearchType = () => {
    setSearchTypeToggle(!searchTypeToggle);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setCustomerALLOrdersData([]);
    setSelectedInvoiceNos([])
    setPage(0);
    setSearchTermClean(true);
  };

  

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div className="cursor-pointer">
        <span style={{ color: "blue", textDecoration: "underline" }}>
          {rowData?.deliveryRequest.order.invoiceNo}
        </span>
      </div>
    );
  };
  
  const handleSelectionChange = (e) => {
    setSelectedRows(e.value);
    const invoiceNumbers =e.value.map((row) => 
      row.deliveryRequest.order.invoiceNo,
    );
    setSelectedInvoiceNos(invoiceNumbers);
    const invoiceId = e.value.map((row) => row.deliveryRequest.order.id);
    setSelectedOrderIds(invoiceId);
    updateStatusTotals(e.value);
  };

  // Update status totals based on fetched data
  const updateStatusTotals = (orders) => {
    const statusTotals = orders.reduce((acc, order) => {
      const existingStatus = acc.find((item) => item.status === order.status);

      if (existingStatus) {
        existingStatus.balanceAmountSum += order.balanceAmount;
        existingStatus.orderCount += 1;
      } else {
        acc.push({
          status: order.status,
          balanceAmountSum: order.balanceAmount,
          orderCount: 1,
        });
      }
      return acc;
    }, []);

    const totalBalanceAmountSumData = statusTotals.reduce(
      (acc, item) => acc + item.balanceAmountSum,
      0
    );
    const totalOrderCountData = statusTotals.reduce(
      (acc, item) => acc + item.orderCount,
      0
    );

    setSumOfBalanceAmount(totalBalanceAmountSumData);
    setSumOfOrderCount(totalOrderCountData);
  };
 

  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={customerALLOrdersData}
        // header={header}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "40rem" }}
        selectionMode="checkbox"
        selection={selectedRows}
        onSelectionChange={handleSelectionChange}
        stripedRows
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          selectionMode="multiple"
          //  header="Select All"
          style={{ width: "50px" }}
        ></Column>

        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{ width: "130px" }}
          body={invoiceBodyTemplate}
        ></Column>

        <Column
          field="customerName"
          header="Customer Name"
          style={{ width: "180px" }}
          body={(rowData) => rowData?.deliveryRequest.order.customerName?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="paidAmount"
          header="Paid Amount"
          style={{ width: "150px" }}
          body={(rowData) => rowData?.deliveryRequest.order.paidAmount}
        ></Column>
        <Column
          field="balanceAmount"
          header="Balance"
          style={{ width: "100px" }}
          body={(rowData) => rowData?.deliveryRequest.order.balanceAmount}
        ></Column>
      </DataTable>
    );
  };

  const RenderSelectedTabView = () => {
    return (
      <DataTable
        showGridlines
        value={selectedRows}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "40rem" }}
        stripedRows
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{ width: "130px" }}
          body={invoiceBodyTemplate}
        ></Column>

        <Column
          field="customerName"
          header="Customer Name"
          style={{ width: "180px" }}
          body={(rowData) => rowData?.deliveryRequest.order.customerName?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="paidAmount"
          header="Paid Amount"
          style={{ width: "150px" }}
          body={(rowData) => rowData?.deliveryRequest.order.paidAmount}
        ></Column>
        <Column
          field="balanceAmount"
          header="Balance"
          style={{ width: "100px" }}
          body={(rowData) => rowData?.deliveryRequest.order.balanceAmount}
        ></Column>
      </DataTable>
    );
  };

  const handleAssignedToRider = () => {
    if (!customerALLOrdersData) return;
    setIsPayNowButtonPressed(true);
    const data = {
      status: 'OUT_FOR_DELIVERY',
      invoiceList: selectedInvoiceNos,
    };
    closeOrder(brandId, storeId, data)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            setModalVisible(true);
            setModalStatus('success');
            setModalText('Orders UpDated Successfully');
          } else {
            setModalVisible(true);
            setModalStatus('notSuccess');
            setModalText('Orders UpDated Failed');
          }
          setCustomerALLOrdersData([]);
          setSelectedInvoiceNos([]);
          setSelectedOrderIds([]);
          handleClearSearch();
          setSelectedRows([]);
          setSumOfOrderCount(0);
          setIsPayNowButtonPressed(false);
          // setAssignRiderValue('');
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/BulkProcessingList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Bulk {state.replace(/_/g, " ")}
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div className="mt-4 mx-4 flex-1">
            <FloatLabel>
              <Dropdown
                id="assignRiderValue"
                value={assignRiderValue}
                onChange={(e) => handleAssignRiderChange(e.target.value)}
                options={riderInfo}
                optionLabel="name"
                placeholder="Assign Rider"
                disabled={selectedRows.length > 0 ? true : false}
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              <label
                htmlFor="assignRiderValue"
                className="text-md"
                style={{ color: "blue" }}
              >
                Assign Rider <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        

      {assignRiderValue && <div className="  my-2">
        <div className="mt-3 mx-4 flex flex-1">
          <div className="flex-1 flex justify-content-center">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder={
                  searchFilterValue === "NAME"
                    ? "Search By Name"
                    : searchFilterValue === "MOBILE"
                    ? "Search By Mobile No."
                    : "Search By Invoice No."
                }
                value={searchTerm}
                keyboardType={
                  searchFilterValue === "NAME" ? "default" : "numeric"
                }
                onChange={(e) => searchTermApiCall(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>

          {searchTerm ? (
            <div
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
              onClick={handleClearSearch}
            >
              <div>
                <p className="text-4xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            </div>
          ) : (
            <div
              onClick={handleSearchType}
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
            >
              <div>
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                  style={{ width: 27 }}
                />
              </div>
            </div>
          )}
        </div>
        {searchTypeToggle && (
          <div className="flex-1 mx-5 mb-4 mt-4">
            <Dropdown
              value={searchFilterValue}
              onChange={(e) => handleSearchFilterChange(e.value)}
              options={FilterList}
              optionLabel="name"
              placeholder="Search Filter"
              className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
            />
          </div>
        )}

        {sumOfOrderCount > 0 && (
          <div className="flex direction-row mt-3">
              <div
              className="flex gap-3 mb-3 mx-4 pb-1 new-scroll-bar cursor-pointer"
              onClick={handleAssignedToRider}
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <div
                style={{ backgroundColor: isPayNowButtonPressed ? '#c2c2c2' : '#2B70D7', paddingTop:"10px", paddingBottom:"9px" }}
                className="px-3 border-round-md flex flex-row gap-5"
              >
                <p className="text-white text-lg font-bold uppercase">
                {sumOfOrderCount} - Order Ready For Out For Delivery
                </p>
                <p className="text-white text-lg font-bold uppercase">
                  Click Here
                </p>
              </div>
            </div>
             
          </div>
        )}

        <div className="flex">
           
            <div>
              <div className="flex justify-content-center">
                <p className="text-xl font-semibold underline p-2">
                  Please Select Invoice
                </p>
              </div>
              {tabularView === "tab" && (
                <div
                  className="scroll-bar mb-2"
                  style={{
                    height: height > 600 ? 420 : 360,
                    overflowY: "scroll",
                  }}
                >
                  <div className="mx-4 report-table">
                    <div className="tab-view-table">{RenderTabView()}</div>
                  </div>
                </div>
              )}
            </div>
          
          <div>
            <div className="flex justify-content-center">
              <p className="text-xl font-semibold underline p-2">
                Selected Invoices
              </p>
            </div>
            {tabularView === "tab" && (
              <div
                className="scroll-bar mb-2"
                style={{
                  height: height > 600 ? 420 : 360,
                  overflowY: "scroll",
                }}
              >
                <div className="mx-4 report-table">
                  <div className="tab-view-table">
                    {RenderSelectedTabView()}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
        <StoreMenu setVisible={setVisible} visible={visible} />
      </div>}
        <ButtonLink />
    </div>
  );
};

export default BulkOutForDelivery;
